import { Box, Tooltip } from '@material-ui/core'; // eslint-disable-line import/no-extraneous-dependencies
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import useFetch from 'use-http';
import {
  BOOK_ID,
  BRIDGE_BOOK_ID,
  BRIDGE_ID,
  CMS_PLAN_ID,
  IG_CONSUL,
  IM,
} from '../../commons/constants/key';
import { COMMON_INFO, CONSULTING, LOGOUT } from '../../commons/constants/url';
import { AppContext } from '../../commons/helpers/appContext';
import { ReactComponent as ExIcon } from '../../commons/icons/ex-icon.svg';
import { ReactComponent as BasicInfoIcon } from '../../commons/icons/sidebar/basic-info.svg';
import { ReactComponent as CitationIcon } from '../../commons/icons/sidebar/citation.svg';
import { ReactComponent as ConsultingIcon } from '../../commons/icons/sidebar/consulting.svg';
import { ReactComponent as ContactIcon } from '../../commons/icons/sidebar/contact.svg';
import { ReactComponent as PostReviewIcon } from '../../commons/icons/sidebar/google.svg';
import { ReactComponent as DashboardIcon } from '../../commons/icons/sidebar/instagram.svg';
import { ReactComponent as LocationIcon } from '../../commons/icons/sidebar/location-new.svg';
import { ReactComponent as MessageIcon } from '../../commons/icons/sidebar/message.svg';
import { ReactComponent as TopIcon } from '../../commons/icons/sidebar/top.svg';
import { ReactComponent as UserIcon } from '../../commons/icons/sidebar/user-new.svg';
import config from '../../OEMConfig';
import './default_sidebar.scss';

function Sidebar() {
  const { t } = useTranslation();
  const history = useHistory();
  const logout = () => history.push(LOGOUT);
  // const inquiry = () => history.push(INQUIRY);
  const location = useLocation();
  const [unsupportedContactCount, setUnsupportedContactCount] = useState(0);
  const [unreadImportantMessageCount, setUnreadImportantMessageCount] =
    useState(0);
  const locationAdd = () => {
    const url = config().app_location_add_url;
    window.open(url, '_blank');
  };
  const releaseNote = () => {
    const url = config().app_release_note_url;
    window.open(url, '_blank');
  };
  const manual = () => {
    const url = config().app_manual_url;
    window.open(url, '_blank');
  };
  const {
    isAdmin,
    services,
    isIgConsult,
    setIsIgConsult,
    showInfdb,
    showCitation,
  } = useContext(AppContext);
  const { get: getConsultInfo } = useFetch(CONSULTING);

  useEffect(async () => {
    const dataConsult = await getConsultInfo();
    if (dataConsult?.success) {
      setIsIgConsult(dataConsult?.result?.isIgConsult);
    }
  }, []);

  const { get: getCommonInfo, response } = useFetch(COMMON_INFO);

  useEffect(async () => {
    const data = await getCommonInfo();
    if (response.ok) {
      setUnsupportedContactCount(data?.result?.unsupportedContactCount);
      setUnreadImportantMessageCount(data?.result?.unreadImportantMessageCount);
    }
  }, [location]);

  return (
    <div className="default_sidebar">
      <div className="default-sidebar-first-tab-height">
        {((!config().is_hide_top && services.has(BRIDGE_ID)) ||
          services.has(IG_CONSUL) ||
          services.has(BOOK_ID) ||
          services.has(BRIDGE_BOOK_ID) ||
          services.has(CMS_PLAN_ID)) && (
          <NavLink to="/top" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <TopIcon />
              </Box>
              <Box className="text">{t('common:SIDEBAR.TOP')}</Box>
            </Box>
          </NavLink>
        )}
        {(services.has(BRIDGE_ID) ||
          services.has(IG_CONSUL) ||
          services.has(BRIDGE_BOOK_ID) ||
          services.has(CMS_PLAN_ID)) && (
          <NavLink to="/dashboard" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <DashboardIcon />
              </Box>
              <Box className="text">{t('common:SIDEBAR.DASHBOARD')}</Box>
            </Box>
          </NavLink>
        )}
        {(services.has(BOOK_ID) || services.has(BRIDGE_BOOK_ID)) && (
          <NavLink to="/gmb" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <PostReviewIcon />
              </Box>
              <Box className="text">{t('common:SIDEBAR.POST_REVIEW')}</Box>
            </Box>
          </NavLink>
        )}
        {(services.has(BOOK_ID) || services.has(BRIDGE_BOOK_ID)) && (
          <NavLink to="/basic-info" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <BasicInfoIcon />
              </Box>
              <Box className="text">{t('common:SIDEBAR.BASIC_INFO')}</Box>
            </Box>
          </NavLink>
        )}
        {(services.has(BRIDGE_ID) ||
          services.has(IG_CONSUL) ||
          services.has(IM) ||
          services.has(BRIDGE_BOOK_ID) ||
          services.has(CMS_PLAN_ID)) && (
          <NavLink to="/message" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <MessageIcon />
              </Box>
              <Box className="text">{t('common:SIDEBAR.MESSAGE')}</Box>
              {unreadImportantMessageCount > 0 && (
                <Tooltip
                  title={
                    <span style={{ whiteSpace: 'pre-line' }}>
                      {t('common:SIDEBAR.UNREAD_IMPORTANT_MESSAGE_ALERT')}
                    </span>
                  }
                  placement="right"
                  disableFocusListener
                  arrow
                  interactive
                  style={{ cursor: 'pointer' }}
                >
                  <ExIcon className="ex-icon" />
                </Tooltip>
              )}
            </Box>
          </NavLink>
        )}
        {isIgConsult && (
          <NavLink to="/consult" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <ConsultingIcon />
              </Box>
              <Box className="text">{t('common:SIDEBAR.CONSULTING')}</Box>
              {unsupportedContactCount > 0 && (
                <Tooltip
                  title={
                    <span style={{ whiteSpace: 'pre-line' }}>
                      {t('common:SIDEBAR.CONSULTING_ALERT')}
                    </span>
                  }
                  placement="right"
                  disableFocusListener
                  arrow
                  interactive
                  style={{ cursor: 'pointer' }}
                >
                  <ExIcon className="ex-icon" />
                </Tooltip>
              )}
            </Box>
          </NavLink>
        )}
        {services.has(BRIDGE_BOOK_ID) && showInfdb?.showInfdb && (
          <NavLink
            to="/influencer/search"
            activeClassName="selected"
            className="menu"
          >
            <Box display="flex" alignItems="center">
              <Box>
                <ManageSearchIcon
                  style={{ width: 24, height: 22, marginRight: 10 }}
                />
              </Box>
              <Box className="text">{t('common:SIDEBAR.INFLUENCER_DB')}</Box>
            </Box>
          </NavLink>
        )}
        {showCitation?.showCitation && (
          <NavLink to="/citations" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <CitationIcon
                  style={{ width: 24, height: 22, marginRight: 10 }}
                />
              </Box>
              <Box className="text">{t('common:SIDEBAR.CITATION')}</Box>
            </Box>
          </NavLink>
        )}
      </div>
      <div>
        <NavLink to="/locations" activeClassName="selected" className="menu">
          <Box display="flex" alignItems="center">
            <Box>
              <LocationIcon />
            </Box>
            <Box className="text">{t('common:SIDEBAR.LOCATION')}</Box>
          </Box>
        </NavLink>
        {isAdmin && (
          <NavLink to="/users" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <UserIcon />
              </Box>
              <Box className="text">{t('common:SIDEBAR.USER')}</Box>
            </Box>
          </NavLink>
        )}
        {!config().is_hide_inquery && (
          <NavLink to="/inquiries" activeClassName="selected" className="menu">
            <Box display="flex" alignItems="center">
              <Box>
                <ContactIcon />
              </Box>
              <Box className="text">{t('common:SIDEBAR.INQUIRY')}</Box>
            </Box>
          </NavLink>
          //   <div className="pills" role="presentation" onClick={inquiry}>
          //   {t('common:SIDEBAR.INQUIRY')}
          // </div>
        )}
        <div className="divider" />
        {config().app_location_add_url && (
          <div className="menu" role="presentation" onClick={locationAdd}>
            <Box className="text no-icon">
              {t(config().app_location_add_text)}
            </Box>
          </div>
        )}
        <div className="divider" />
        {config().app_release_note_url && (
          <div className="menu" role="presentation" onClick={releaseNote}>
            <Box className="text">
              {t('common:SIDEBAR.RELEASE_NOTE')}
              <div className="updateDate">
                {t('common:SIDEBAR.UPDATE_DATE')}
              </div>
            </Box>
          </div>
        )}
        <div className="divider" />
        {config().app_manual_url && (
          <div className="menu" role="presentation" onClick={manual}>
            <Box className="text">{t('common:SIDEBAR.MANUAL')}</Box>
          </div>
        )}
        <div className="menu" role="presentation" onClick={logout}>
          <Box className="text">{t('common:SIDEBAR.LOGOUT')}</Box>
        </div>
      </div>

      {/* <Box minHeight="200px" /> */}
    </div>
  );
}

export default Sidebar;
